<script setup lang="ts">
defineProps<{
  label: string;
}>();
</script>

<template>
  <div
    class="grid grid-cols-[6.5rem_minmax(0,1fr)] items-start gap-2 border-t border-base py-1.5 first:border-t-0 first:pt-0"
  >
    <dt class="text-xs subtitle leading-5">
      {{ label }}
    </dt>
    <dd class="min-w-0 text-sm leading-5">
      <slot />
    </dd>
  </div>
</template>
